<template>
  <div
    @mousedown="clickModalOverlay($event);"
    class="overlay d-flex justify-content-center align-items-center h-100"
    id="modal"
  >
    <div class="bg-white p-1 rounded-top slim-form shadow-sm position-relative">
      <a
        v-if="showCloseButton"
        v-on:click="closeModals()"
        class="close-modal"
      ><i class="fal fa-times"></i></a>
      <formLogo />
      <div class="text-center my-3 ">
        <h1 class="h3 m-0">
          <slot name="heading">

          </slot>
        </h1>
        <slot
          class="small mb-5 mt-1"
          name="description"
        >

        </slot>

      </div>
      <slot name="content">

      </slot>
    </div>
  </div>
</template>

<script>
import formLogo from "../form/FormLogo";
export default {
  beforeDestroy() {
    if (this.nextRoute) {
      this.$router.push(this.nextRoute).catch(() => {});
    }
  },
  components: {
    formLogo,
  },
  props: {
    showCloseButton: {
      type: Boolean,
      required: false,
      default: true,
    },
    nextRoute: {
      type: Object,
      required: false,
    },
  },
};
</script>
